

































import ProjectInfo from '../components/ProjectInfo.vue';
import Vue from 'vue';
import Project, { ProjectDef } from '@/types/Project';
import {ProjectInfoState as State} from '@/components/types/ProjectInfoState';
import emulatorVersions from '../emulatorVersions';

export default Vue.extend({
    components: {
        ProjectInfo,
    },

    data() : {
        state: State,
        error: string,
        project: Project,
        originalName: string,
    } {
        return {
            state: State.NotStarted,
            error: 'No error',
            project: { ...this.$store.state.project!.projectDef!.project },
            originalName: this.$store.state.project!.projectDef!.project.name,
        };
    },

    methods: {
        async handleSubmit(project: Project) : Promise<void> {
            this.state = State.Saving;
            try {
                await this.$store.dispatch('project/update', { project, id: this.$store.state.project!.projectDef!.id } as ProjectDef);
                this.state = State.Done;
                await this.$router.push(`/editor/${this.$store.state.project!.projectDef!.id}`);
            } catch (e) {
                this.error = e.message;
                this.state = State.Error;
            }
        },

        async deleteProject() : Promise<void> {
            if (window.prompt(`This will DELETE THIS PROJECT and all of its files, without chance of recovery. Are you sure you want to proceed? If so, type 'delete' in the field below.`) !== 'delete')
                return;
            this.state = State.Saving;
            try {
                await this.$store.dispatch('project/delete', this.$store.state.project!.projectDef!.id);
                this.state = State.Done;
                await this.$router.push('/projects');
            } catch (e) {
                this.error = e.message;
                this.state = State.Error;
            }
        },

        async upgradeProject() : Promise<void> {
            if (!window.confirm(`This will upgrade the compiler and emulator version for this project from ${this.project.archVersion} to ${emulatorVersions[0]}. THIS MIGHT BE A BREAKING CHANGE AND YOU CAN'T RETURN TO THE PREVIOUS VERSION! Are you sure you want to proceed?`))
                return;
            this.state = State.Saving;
            try {
                await this.$store.dispatch('project/upgradeToLatest');
                this.state = State.Done;
                await this.$router.push('/projects');
            } catch (e) {
                this.error = e.message;
                this.state = State.Error;
            }
        },

        async cancel() : Promise<void> {
            await this.$router.push(`/editor/${this.$store.state.project!.projectDef!.id}`);
        },
    },
});
